import locales from '@/components/language/app.js'
var curLang = locales[localStorage.lang_jp]

export default {
	install(Vue) {
		Vue.prototype.$hwver = [
			'S.A1.K3',
			'S.B1.K3',
			'ZT4G',
		]

		Vue.prototype.$eqBindSt = {
			// '0': '未绑定',
			// '1': '绑定',
			'0': curLang.select_option.un_bond,
			'1': curLang.select_option.bind,
		}
		Vue.prototype.$eqBindOper = {
			// '0': '绑定',
			// '1': '解绑',
			'0': curLang.select_option.bind,
			'1': curLang.select_option.un_bind,
		}
		Vue.prototype.$devpSt = {
			// '0': '停用',
			// '1': '启用'
			'0': curLang.select_option.app_disabled,
			'1': curLang.select_option.app_enable,
		}
		Vue.prototype.$agAcSt = {
			// '0': '停用',
			// '1': '启用'
			'0': curLang.select_option.app_disabled,
			'1': curLang.select_option.app_enable,
		}
		Vue.prototype.$plat = {
			// '002T': '四川优友宝',
			'002T': curLang.select_option.app_youyoubao,
		}
		Vue.prototype.$plats = [{
			vl: '002T',
			// lb: '四川优友宝'
			lb: curLang.select_option.app_youyoubao,
		}, ]
		Vue.prototype.$ugUpdateSts = [{
				vl: '0',
				// lb: '待更新'
				lb: curLang.select_option.pending_upgrade,
			},
			{
				vl: '1',
				// lb: '已更新'
				lb: curLang.select_option.app_updated,
			}
		]
		Vue.prototype.$ugUpdateSt = {
			// '0': '待更新',
			// '1': '已更新',
			'0': curLang.select_option.pending_upgrade,
			'1': curLang.select_option.app_updated,
		}
		Vue.prototype.$ugEqType = {
			'0': 'WiFi',
			'1': 'GPRS + WiFi',
			'2': '4G+W',
			'3': '4G'
		}
		Vue.prototype.$ugEqTypes = [{
				vl: '0',
				lb: 'WiFi'
			},
			{
				vl: '1',
				lb: 'GPRS + WiFi'
			},
			{
				vl: '2',
				lb: '4G+W'
			},
			{
				vl: '3',
				lb: '4G'
			},
		]

		Vue.prototype.$nwtypes = [{
				vl: '1',
				lb: 'WiFi'
			},
			{
				vl: '2',
				lb: '2G+WiFi'
			},
			{
				vl: '3',
				lb: '4G+WiFi'
			},
			{
				vl: '4',
				lb: '4G'
			},
			{
				vl: '5',
				lb: '2G'
			},
		]
		Vue.prototype.$nwtype = {
			'1': 'WiFi',
			'2': '2G+WiFi',
			'3': '4G/4G+WiFi'
		}

		Vue.prototype.$pushtypes = [{
				vl: '0',
				// lb: '未推送'
				lb: curLang.select_option.app_notpushed,
			},
			{
				vl: '1',
				// lb: '已推送'
				lb: curLang.select_option.app_message_pushed,
			}
		]

		Vue.prototype.$playSts = [{
				vl: 'send',
				// lb: '已发送'
				lb: curLang.select_option.app_send,
			},
			{
				vl: 'succeed',
				// lb: '成功'
				lb: curLang.select_option.app_succeed,
			},
			{
				vl: 'offline',
				// lb: '离线'
				lb: curLang.select_option.app_offline,
			},
			{
				vl: 'error',
				// lb: '异常'
				lb: curLang.select_option.app_error,
			}
		]
		Vue.prototype.$playSt = {
			// 'send': '已发送',
			// 'succeed': '成功',
			// 'offline': '离线',
			// 'error': '异常',
			'send': curLang.select_option.app_send,
			'succeed': curLang.select_option.app_succeed,
			'offline': curLang.select_option.app_offline,
			'error':  curLang.select_option.app_error,
		}
		Vue.prototype.$ugrdEvs = [{
				// lb: '不等于任务版本',
				lb: curLang.select_option.no_version,
				vl: 'neq'
			},
			{
				// lb: '小于任务版本',
				lb: curLang.select_option.less_version,
				vl: 'lt'
			}
		]
		Vue.prototype.$ugrdEv = {
			// 'neq': '不等于任务版本',
			// 'lt': '小于任务版本',
			'neq': curLang.select_option.no_version,
			'lt': curLang.select_option.less_version,
		}
		Vue.prototype.$equipSts = [
			// {vl:'unknow', lb:'未初始化'},
			{
				vl: 'unknown',
				// lb: '未初始化'
				lb: curLang.app_un_init
			},
			{
				vl: 'online',
				// lb: '在线'
				lb: curLang.select_option.app_online,
			},
			{
				vl: 'offline',
				// lb: '离线'
				lb: curLang.select_option.app_offline,
			}
		]

		Vue.prototype.$dvOFSts = [{
				vl: '',
				// lb: '所有状态'
				lb: curLang.select_option.all_status,
			},
			{
				vl: '0',
				// lb: '上线'
				lb: curLang.select_option.go_line,
			},
			{
				vl: '1',
				// lb: '下线'
				lb: curLang.select_option.go_offline,
			},
			{
				vl: '2',
				// lb: '更新'
				lb: curLang.select_option.app_update,
			}
		]
		Vue.prototype.$dvOFSt = {
			// '0': '上线',
			// '1': '下线',
			// '2': '更新',
			'0': curLang.select_option.go_line,
			'1': curLang.select_option.go_offline,
			'2': curLang.select_option.app_update,
		}
		Vue.prototype.$roles = [{
				vl: 2,
				// lb: '渠道商'
				lb: curLang.select_option.app_agent,
			},
			{
				vl: 3,
				// lb: '普通管理员'
				lb: curLang.select_option.app_ordinary,
			},
			{
				vl: 4,
				// lb: '产线管理员'
				lb: curLang.select_option.app_production,
			}
		]
		Vue.prototype.$roles1 = [{
				vl: 2,
				// lb: '渠道商'
				lb: curLang.select_option.app_agent,
			},
			{
				vl: 3,
				// lb: '普通管理员'
				lb: curLang.select_option.app_ordinary,
			}
		]
		Vue.prototype.$roleSt = {
				// 'Admin': '超级管理员',
				// 'Agent': '渠道商',
				// 'Ordinary': '普通管理员',
				// 'Production': '产线管理员',
				'Admin': curLang.select_option.app_admin,
				'Agent': curLang.select_option.app_agent,
				'Ordinary': curLang.select_option.app_ordinary,
				'Production': curLang.select_option.app_production,
			},
			Vue.prototype.$itaskty = {
				// '0': '升级任务导入',
				// '1': '设备导入',
				'0': curLang.select_option.app_task_import,
				'1': curLang.select_option.app_device_import,
			}

	}
}
